import { render } from "./InListRecord.vue?vue&type=template&id=bdc2cbb8"
import script from "./InListRecord.vue?vue&type=script&lang=js"
export * from "./InListRecord.vue?vue&type=script&lang=js"

import exportComponent from "E:\\heguang\\hotel\\src\\manage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__